import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function bindCtaBannerReveal(section) {
	const backCard = section.querySelector('.cta-banner__card--back');
	const frontCard = section.querySelector('.cta-banner__card--front');
	const ctaButton = section.querySelector('.cta-banner__secondary-cta');

	if (!backCard || !frontCard) {
		return null;
	}

	const targets = ctaButton ? [backCard, frontCard, ctaButton] : [backCard, frontCard];
	const timeline = gsap.timeline({ paused: true });

	timeline.from(
		[backCard, frontCard],
		{
			autoAlpha: 0,
			y: 56,
			scale: 0.92,
			duration: 0.85,
			ease: 'power3.out',
			stagger: 0.12,
		},
		0,
	);

	if (ctaButton) {
		timeline.from(
			ctaButton,
			{
				autoAlpha: 0,
				y: 24,
				duration: 0.55,
				ease: 'power2.out',
			},
			0.28,
		);
	}

	const trigger = ScrollTrigger.create({
		trigger: section,
		start: 'top 78%',
		once: true,
		onEnter: () => timeline.play(),
	});

	return () => {
		trigger.kill();
		timeline.kill();
		gsap.set(targets, { clearProps: 'opacity,visibility' });
	};
}

export function initCtaBannerScrollAnimation() {
	const sections = document.querySelectorAll('.section--cta-banner');

	if (!sections.length) {
		return;
	}

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
		sections.forEach((section) => {
			const cleanup = bindCtaBannerReveal(section);

			if (cleanup) {
				cleanups.push(cleanup);
			}
		});

		return () => {
			cleanups.forEach((fn) => fn());
		};
	});
}
